import React from 'react';
import { Link } from 'react-router-dom';
import { Info, ArrowUpRight } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

/**
 * Icono informativo reutilizable: explica de dónde sale el dato y enlaza a la pantalla de origen.
 * <InfoTip title="Tasa de cierre" text="..." to="/deals" linkLabel="Ver pipeline" />
 */
export const InfoTip = ({ title, text, source, to, linkLabel = 'Ver más', className = '', testId }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        aria-label={`Más información sobre ${title || 'esta métrica'}`}
        data-testid={testId || `infotip-${(title || 'metric').toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
        onClick={(e) => e.stopPropagation()}
        className={`inline-flex items-center justify-center rounded-full text-muted-foreground hover:text-primary hover:bg-primary/10 transition-colors w-5 h-5 shrink-0 ${className}`}
      >
        <Info className="w-3.5 h-3.5" />
      </button>
    </PopoverTrigger>
    <PopoverContent
      align="start"
      className="w-72 rounded-2xl border-border bg-popover text-popover-foreground p-4 space-y-2 z-50"
      onClick={(e) => e.stopPropagation()}
    >
      {title && <p className="text-sm font-semibold text-foreground">{title}</p>}
      {text && <p className="text-xs text-muted-foreground leading-relaxed">{text}</p>}
      {source && (
        <p className="text-[11px] text-muted-foreground/80 border-t border-border pt-2">
          <span className="font-medium text-foreground/80">Origen del dato: </span>{source}
        </p>
      )}
      {to && (
        <Link
          to={to}
          className="inline-flex items-center gap-1 text-xs font-semibold text-primary hover:underline"
          data-testid={`infotip-link-${to.replace(/\//g, '')}`}
        >
          {linkLabel} <ArrowUpRight className="w-3 h-3" />
        </Link>
      )}
    </PopoverContent>
  </Popover>
);

export default InfoTip;
